export function isOrderConfirmationRoute(semanticRoute?: string): boolean {
  return semanticRoute === 'orderConfirmation';
}

export function isCheckoutRoute(semanticRoute?: string): boolean {
  return semanticRoute === 'checkout';
}
